import React from 'react'
import Sidebar from '@/components/Sidebar/Sidebar';
import { useParams } from 'react-router-dom';
import { useQuery } from '@/context/hazumi/hooks/useQuery';
import OffreForm from './partials/OffreForm/OffreForm';
import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation';

const OffreCreate = () => {
    const { offreId } = useParams();

    const { data, loading } = useQuery(`/api/offres/detail/${offreId}`, {
        fetchCondition: parseInt(offreId) > 0
    });

    return (
        <div className=''>
            <div className="h-screen w-screen flex bg-gray-200">
                <Sidebar />
                <section className="w-full bg-white flex justify-center items-start">
                    <div className="w-1/3 mt-8 border border-gray-200 p-10 rounded-lg">
                        { loading ? <LoadingAnimation /> : <OffreForm {...data}/> }
                    </div>
                </section>
            </div>
        </div>
    )
}

export default OffreCreate